import React from 'react';
import PopoverOnInteraction from '../../../Popover/PopoverOnInteraction';
var ConditionalTooltip = function (_a) {
    var showTooltip = _a.showTooltip, tooltipContent = _a.tooltipContent, children = _a.children;
    if (showTooltip) {
        return (React.createElement(PopoverOnInteraction, { placement: "right", popoverContent: tooltipContent, listenOnHover: true }, children));
    }
    return React.createElement(React.Fragment, null, children);
};
ConditionalTooltip.displayName = 'ConditionalTooltip';
export default ConditionalTooltip;
//# sourceMappingURL=ConditionalTooltip.js.map